import styled from 'styled-components';
import { onSurface, popoverShadow, radiusFull, surface } from '../themeTokens';

// Moved by the stage every frame through its transform; hidden until first placed.
export const LabelPill = styled.div<{ $tint: string }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  padding: 5px 12px;
  border: 1px solid color-mix(in srgb, ${(p) => p.$tint} 55%, transparent);
  border-radius: ${radiusFull};
  background: color-mix(in srgb, ${surface} 88%, transparent);
  backdrop-filter: blur(6px);
  box-shadow: ${popoverShadow};
  color: ${onSurface};
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  pointer-events: none;
  visibility: hidden;
`;

export const AxisLetter = styled.b<{ $tint: string }>`
  font-size: 11px;
  letter-spacing: 0.14em;
  color: ${(p) => p.$tint};
`;
